<template>
  <banner :rounded="true" :showImage="false">
    <!-- Mobile View -->
    <div class="w-full grid gap-4 py-4 md:hidden">
      <div
        class="
          text-white
          rounded-xl
          grid grid-cols-3
          md:gap-8
          gap-x-4 gap-y-8
          w-full
          max-w-lg
          justify-self-center
        "
      >
        <div class="col-span-2">
          <p class="text-xs text-gray-300">Available to spend</p>
          <p class="text-xl font-bold">
            {{ $filters.formatMoney(creditAccountInfo?.availableCreditLimit) }}
          </p>
        </div>
        <div class="justify-self-end text-right">
          <p class="text-gray-300 text-xs">Approved Limit</p>
          <p class="text-xl text-right">
            {{ $filters.formatMoney(creditAccountInfo?.approvedLimit || 0) }}
          </p>
        </div>
        <div class="col-span-full">
          <progress-bar
            :upperLimit="creditAccountInfo?.approvedLimit"
            :currentLimit="creditAccountInfo?.availableCreditLimit"
          ></progress-bar>
        </div>
        <div
          class="grid grid-cols-2 col-span-2"
          :class="
            creditAccountInfo?.outstandingDue
              ? 'grid grid-cols-2 col-span-2'
              : 'flex justify-between gap-4 col-span-full'
          "
        >
          <div>
            <p class="text-gray-300 text-xs">Redeemable Points</p>
            <p class="text-xl font-bold text-left">
              {{
                $filters.formatMoney(creditAccountInfo?.redeemableLoyaltyPoint)
              }}
            </p>
          </div>
          <div
            class
            :class="{ 'text-right': !creditAccountInfo?.outstandingDue }"
          >
            <p class="text-xs text-gray-300">Amount Payable</p>
            <p class="text-xl font-bold">
              {{ $filters.formatMoney(creditAccountInfo?.outstandingDue) }}
            </p>
          </div>
        </div>
        <section
          class="justify-self-end self-end"
          v-if="creditAccountInfo?.outstandingDue"
        >
          <custom-button
            v-if="creditAccountInfo?.outstandingDue"
            @click.prevent="customerTransactionRedirect"
            variant="white"
            size="small">
              Pay Now
          </custom-button>
        </section>
      </div>
    </div>
    <!-- Desktop View -->
    <div class="w-full px-6 hidden md:block">
      <div
        class="
          text-sm
        text-gray-700
          grid grid-cols-4
          gap-x-10 gap-y-6
        "
      >
        <!-- Cards -->
        <section class="col-span-1 rounded-md bg-white p-4">
          <elements class="flex gap-4 justify-center">
            <span>
              <img src='@/assets/CreditStatement.svg' alt="CreditStatement"/>
            </span>
            <div class="gap-4">
              <p class="text-sm text-gray-700 font-semibold pb-1">Available to <br/> spend</p>
              <p class="text-sm text-gray-700">
                {{ $filters.formatMoney(creditAccountInfo?.availableCreditLimit) }}
              </p>
            </div>
          </elements>
          <div class="pt-4 justify-center grid">
            <router-link
              :to="{
                name: 'Credit Statement',
              }"
            >
              <custom-button variant="primary" size="average" >Credit Statement</custom-button>
            </router-link>
          </div>
        </section>

         <section class="col-span-1 rounded-md bg-white p-4">
          <elements class="flex gap-4  justify-center">
            <span>
              <img src='@/assets/LoanOffers.svg' alt="LoanOffers"/>
            </span>
            <div class="gap-4">
              <p class="text-sm text-gray-700 font-semibold pb-1">Approved <br/> Limit</p>
              <p class="text-sm text-gray-700">
                {{ $filters.formatMoney(creditAccountInfo?.approvedLimit || 0) }}
              </p>
            </div>
          </elements>
          <div class="pt-4 justify-center grid">
            <router-link
              :to="{
                name: 'Loan Offers',
              }"
            >
              <custom-button variant="primary" size="normal" >Credit Offers</custom-button>
            </router-link>
          </div>
        </section>

         <section class="col-span-1 rounded-md bg-white p-4">
          <elements class="flex gap-4 justify-center">
            <span>
              <img src='@/assets/RewardStatement.svg' alt="RewardStatement"/>
            </span>
            <div class="gap-4">
              <p class="text-sm text-gray-700 font-semibold pb-1">Redeemable <br/> Points</p>
              <p class="text-sm text-gray-700">
                {{ $filters.formatMoney(creditAccountInfo?.redeemableLoyaltyPoint) }}
              </p>
            </div>
          </elements>
          <div class="pt-4 justify-center grid">
            <router-link
              :to="{
                name: 'Reward Statement',
              }"
            >
              <custom-button variant="primary" size="average" >Reward Statement</custom-button>
            </router-link>
          </div>
        </section>

         <section class="col-span-1 rounded-md bg-white p-4 ">
          <elements class="flex gap-4 justify-center">
            <span>
              <img src='@/assets/AmountPayable.svg' alt="MyCards"/>
            </span>
            <div class="gap-4">
              <p class="text-sm text-gray-700 font-semibold pb-1">Amount <br/> Payable</p>
              <p class="text-sm text-gray-700">
                {{ $filters.formatMoney(creditAccountInfo?.outstandingDue) }}
              </p>
            </div>
          </elements>
          <div class="pt-4 justify-center grid">
            <custom-button
              v-if="creditAccountInfo?.outstandingDue"
              @click.prevent="customerTransactionRedirect"
              :loading="isLoading"
              variant="primary"
              size="normal">
                Pay Now
            </custom-button>
            <custom-button  v-else variant="primary" size="normal" class="disableBtn">Pay Now</custom-button>
          </div>
        </section>
      </div>
    </div>
  </banner>
</template>
<script>
import { mapGetters } from 'vuex';
import Banner from './Banner.vue';
import CustomButton from './CustomButton.vue';
import ProgressBar from './ProgressBar.vue';

export default {
  name: 'ApprovedProgressBarCard',
  components: { Banner, ProgressBar, CustomButton },
  computed: {
    ...mapGetters(['creditAccountInfo', 'uuid']),
  },
  data() {
    return {
      isLoading: false,
      creditStatementData: undefined
    };
  },
  methods: {
    customerTransactionRedirect() {
      this.$router.push({ name: 'Credit Statement' });
    },
  }
};
</script>

<style  lang="scss" scoped>
.disableBtn {
  background: lightgray;
  border: none;
  cursor: default;
}
</style>
